<template>
  <el-autocomplete
    clearable
    filterable 
    class="inline-input"
    v-model="inputKW"
    :fetch-suggestions="SearchId"
    :placeholder="ptext"
    @select="SelectApp"
    @clear="clear"
    :suffix-icon="inputKW!=''?'':'el-icon-search'"
    :style="sstyle"
    
  >
    <!--  -->
    <template slot-scope="{ item }">
      <div class="name">{{ item['name'] }}</div>
    </template>
  </el-autocomplete>
</template>
<script>
import { getAppid, getPlist,getIssuedAppList } from "../../api/api.js";
const props = {
  compare: { type: String, default: "name" },
  pholder: { type: String, default: "" },
  sstyle: { type: String, default: "width:200px" },
  platform_id:{type: String, default: "2"}
};
export default {
  props,
  data() {
    return {
      inputKW: this.pholder,
      applist: [],
      compares: this.compare,
      ptext: "请输入小程序名称",
    };
  },
  watch: {
    pholder(val) {
      this.inputKW = val;
    },
    compare(val) {
      this.compares = val;
      //this.SearchId();
    },
    platform_id:{
    	handler(n, o) {
					if(n!=o) {
			    	this.inputKW ='';
						this.$emit("getid", "");
					}
				},
    }
  },
  mounted() {

  },
  methods: {
    // 筛选
    SearchId(str, cb) {
      if(str===null){
        str='';
      }
      if (this.compares == "name") {
        getAppid(str, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            cb(res.data.list);
          }
        });
      } else if (this.compares == "issued") {
  
        getIssuedAppList(
          "page=1&perpage=1000&kw=" + str+'&platform_id='+this.platform_id,
          this.$cookie.getCookie("login")
        ).then(res => {
          if (res.code == 200) {
          	this.applist =res.data;
          	var applist = this.applist;
          	var results = str ? applist.filter(this.createFilter(str)) : applist;
		        // 调用 callback 返回建议列表的数据
            cb(results);
          }
        });
      }
    },
    createFilter(str) {
      return res => {
        return (
          res.name.toLowerCase().indexOf(str.toLowerCase()) === 0
        );
      };
    },
    //选中
    SelectApp(s) {
      this.inputKW = s.name;
      this.$emit("getid", s.id);
      this.$emit("getInfo", s);
    },
    clear() {
      this.$emit("getid", "");
    }
  }
};
</script>



// WEBPACK FOOTER //
// searchApp.vue?4ade6c39